import {NgModule} from '@angular/core';
import {Daterangepicker, DaterangepickerConfig} from 'ng2-daterangepicker';
import {TranslateManager} from '../../../../../common/translate';
import {DateRangePickerComponent} from './date-range-picker.component';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

export const DATE_FORMAT: string = 'DD.MM.YYYY';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        Daterangepicker
    ],
    declarations: [
        DateRangePickerComponent
    ],
    exports: [
        Daterangepicker,
        DateRangePickerComponent
    ]
})
export class DateRangePickerModule {
    constructor(translations: TranslateManager,
                daterangepickerOptions: DaterangepickerConfig) {
        daterangepickerOptions.settings = {
            opens: 'down',
            drops: 'down',
            showDropdowns: true,
            locale: {
                format: DATE_FORMAT,
                firstDay: 1,
                cancelLabel: translations.getValue('COMMON.CLEAR')
            },
            alwaysShowCalendars: false
        };
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/input/daterangepicker/date-range-picker.module.ts